module.exports = __webpack_public_path__ + "img/tailwind.d737ca00.png";